module.exports = __webpack_public_path__ + "media/rev&GOU.846cd367.mp4";